import { render, staticRenderFns } from "./SensorCard.vue?vue&type=template&id=4683790a&scoped=true&"
import script from "./SensorCard.vue?vue&type=script&lang=js&"
export * from "./SensorCard.vue?vue&type=script&lang=js&"
import style0 from "./SensorCard.vue?vue&type=style&index=0&id=4683790a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4683790a",
  null
  
)

export default component.exports